import { getApiClient } from '../../api/client';
import type { components } from '../../api/schema';

type SendSMSRequest = components['schemas']['SendSMSRequest'];

export async function getSMSSession(uuid: string) {
  const client = getApiClient();
  const { data, error } = await client.GET('/sms/{uuid}', {
    params: { path: { uuid } },
  });
  if (error) throw new Error(`Failed to fetch SMS session: ${JSON.stringify(error)}`);
  return data;
}

export async function sendSMS(uuid: string, request: SendSMSRequest) {
  const client = getApiClient();
  const { data, error } = await client.POST('/sms/{uuid}', {
    params: { path: { uuid } },
    body: request,
  });
  if (error) throw new Error(`Failed to send SMS: ${JSON.stringify(error)}`);
  return data;
}
